import { Route, Routes } from 'react-router'
import { SettingAgent } from 'pages/chatbot/pages/agentBookAppointment/pages/settingAgent'
import { ConnectCalendar } from 'pages/chatbot/pages/agentBookAppointment/pages/connectCalendar'
import { AgentActions } from 'pages/chatbot/pages/agentBookAppointment/pages/agentActions'
import { AgentActivate } from 'pages/chatbot/pages/agentBookAppointment/pages/agentActivate'
import { AgentBookAppointmentProviderLayout } from 'pages/chatbot/pages/agentBookAppointment/layout/AgentBookAppointmentProviderLayout'
import { AgentBookAppointmentAccessLayout } from 'pages/chatbot/pages/agentBookAppointment/route/AgentBookAppointmentAccessLayout'
import { AgentBookAppointmentStepsLayout } from 'pages/chatbot/pages/agentBookAppointment/route/AgentBookAppointmentStepsLayout'
import { AgentBookAppointmentStepsRoutes } from './type'

export const AgentBookAppointmentStepsRouter = () => {
  return (
    <Routes>
      <Route element={<AgentBookAppointmentProviderLayout />}>
        <Route element={<AgentBookAppointmentAccessLayout />}>
          <Route element={<AgentBookAppointmentStepsLayout />}>
            <Route path={AgentBookAppointmentStepsRoutes.settingAgent} element={<SettingAgent />} />
            <Route
              path={AgentBookAppointmentStepsRoutes.connectCalendar}
              element={<ConnectCalendar />}
            />
            <Route path={AgentBookAppointmentStepsRoutes.actionsAgent} element={<AgentActions />} />
            <Route
              path={AgentBookAppointmentStepsRoutes.activateAgent}
              element={<AgentActivate />}
            />
            <Route path='*' element={<div>Page Not Found</div>} />
          </Route>
        </Route>
      </Route>
    </Routes>
  )
}
